import { render, staticRenderFns } from "./AggregateFunctionView.vue?vue&type=template&id=58dda255&scoped=true"
import script from "./AggregateFunctionView.vue?vue&type=script&lang=js"
export * from "./AggregateFunctionView.vue?vue&type=script&lang=js"
import style0 from "./AggregateFunctionView.vue?vue&type=style&index=0&id=58dda255&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dda255",
  null
  
)

export default component.exports